import React, { useState, useEffect } from 'react';
import './ModalStyles.css'; // Reusing a generic modal style

const PhaseModal = ({ isOpen, onClose, onSave, phase }) => {
    const [name, setName] = useState(phase?.name || '');
    const [description, setDescription] = useState(phase?.description || '');

    useEffect(() => {
        setName(phase?.name || '');
        setDescription(phase?.description || '');
    }, [phase]);

    const handleSubmit = (e) => {
        e.preventDefault();
        // Preserve all original phase properties to avoid clearing required fields like ProjectId on update
        onSave({ ...phase, name, description, order: phase?.order || 0 });
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3>{phase ? 'Edit Stage' : 'Add New Stage'}</h3>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Name:</label>
                        <input type="text" value={name} onChange={(e) => setName(e.target.value)} required />
                    </div>
                    <div className="form-group">
                        <label>Description:</label>
                        <textarea value={description} onChange={(e) => setDescription(e.target.value)}></textarea>
                    </div>
                    <div className="modal-actions">
                        <button type="submit" className="save-button">Save</button>
                        <button type="button" onClick={onClose} className="cancel-button">Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default PhaseModal;
